export default __webpack_public_path__ + "static/media/zagg..845f8e0a.png";